import React from "react";
import styled from "styled-components";

export const Switch = ({size, onLabel, offLabel, checked, ...props}) => {
	return (
		<StyledLabel className={(size) ? size : null}>
			<input type="checkbox" defaultChecked={checked} {...props} />
			<span></span>
			{(onLabel) ? <span dangerouslySetInnerHTML={{__html : onLabel}}></span> : null}
			{(offLabel) ? <span dangerouslySetInnerHTML={{__html : offLabel}}></span> : null}
		</StyledLabel>
	);
};

const StyledLabel = styled.label`
&									{position:relative; display:inline-flex; padding:0 5px 0.25px 7px; width:46px; height:24px; align-items:center; justify-content:space-between}
input								{position:absolute; left:0; top:0; width:0; height:0; visibility:hidden; opacity:0}
span								{position:relative; font-size:10px; font-weight:500; color:white; transition:opacity 0.3s}
input + span						{position:absolute; left:0; top:0; width:100%; height:100%; background-color:#949db2; border-radius:24px; font-size:0}
input + span:after					{content:""; position:absolute; left:3px; top:3px; width:18px; height:18px; background-color:white; border-radius:100%; transition:left 0.2s}
input:checked + span				{background-color:var(--blue)}
input:checked + span:after			{left:calc(50% + 1.5px)}

input + span + span,
input:checked + span + span + span	{opacity:0}
input:checked + span + span			{opacity:1}

input:disabled + span				{border-color:#ddd}
input:disabled + span:after			{background-color:#ddd}

&.small								{width:30px; height:18px}
&.small input + span:after			{left:2px; top:2px; width:14px; height:14px}
&.small input:checked + span:after	{left:calc(50% - 1px)}

`;

export default Switch;